/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var React = require('react');
var Header = require('./Header');
var readme = require('../../generated/readme.json');

require('../../lib/runkit-embed');

var Index = React.createClass({displayName: "Index",
  render: function() {
    return (
      React.createElement("div", null, 
        React.createElement(Header, null), 
        React.createElement("div", {className: "pageBody", id: "body"}, 
          React.createElement("div", {className: "contents"}, 
            React.createElement("div", {dangerouslySetInnerHTML: { __html: readme}})
          )
        )
      )
    );
  },
});

module.exports = Index;
